import { amplitudeSendEvent, getScreenName } from '@musinsa/frontend-utils';
import { Typography } from '@musinsa/mds';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { useQuery } from '@tanstack/react-query';
import { twMerge } from 'tailwind-merge';
import { getPaths } from '../../common';
import { useNavigate } from '../../common/hooks/useNavigate';
import { curatorQueries } from '../../query-factory';

interface Props {
  className?: string;
  curationType?: 'GOODS' | 'SNAP2' | null;
}

export const CurationOrderEditButton = ({ className, curationType }: Props) => {
  const { service } = useDeviceInfo();
  const { navigate } = useNavigate();
  const paths = getPaths(service);
  const { data: userInfo } = useQuery({ ...curatorQueries.profile.userInfo });

  const onClick = () => {
    if (service === SERVICE.MUSINSA) {
      amplitudeSendEvent({
        action_name: 'click',
        button_name: 'curation_edit_select',
        component_name: 'button',
        event_name: 'click_button',
        from: getScreenName(),
        id: userInfo?.snsTitle ?? '',
        name: 'order_change',
        section_name: 'curator_curationfeed',
        type: curationType === 'SNAP2' ? 'snap' : 'goods',
      });
    }
    navigate(paths.curationOrder());
  };

  return (
    <Typography
      className={twMerge('py-[12px]! space-y-[11px] cursor-pointer', className)}
      colorScheme="gray-600"
      variant="body13pxReg"
      onClick={onClick}
    >
      순서 변경
    </Typography>
  );
};
